import { InputTextDesignTokens } from '@primeuix/themes/types/inputtext';

export const ezInputTextThemeConfig: InputTextDesignTokens = {
  colorScheme: {
    light: {
      root: {
        focusBorderColor: '#167007',
        disabledBackground: 'rgb(var(--ez-primeng-readonly-bg-color-rgb)/40%)',
        borderColor: 'var(--ez-border-color)',
        placeholderColor: 'var(--ez-text-hint-color)',
        hoverBorderColor: 'var(--ez-border-color)',
        color: 'var(--ez-primary-color)',
      },
    },
  },
};
